module.exports = __webpack_public_path__ + "img/rv--icon--gray.086a993c.svg";